
// src/components/checagens/CriarChecagemModal.tsx
import React, { useState } from 'react';
import { useCreateChecagem } from '../../hooks/useChecagens';
import './CriarChecagemModal.css';

interface CriarChecagemModalProps {
  onClose: () => void;
}

const CriarChecagemModal: React.FC<CriarChecagemModalProps> = ({ onClose }) => {
  const [nome, setNome] = useState('');
  const [descricao, setDescricao] = useState('');
  const createChecagemMutation = useCreateChecagem();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    createChecagemMutation.mutate({ nome, descricao, status: 'pendente' }, {
      onSuccess: () => {
        onClose();
      }
    });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Nova Checagem</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="nome">Nome da Checagem (Opcional)</label>
            <input
              id="nome"
              type="text"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              placeholder="Ex: Checagem de Imóveis de Luxo"
            />
          </div>
          <div className="form-group">
            <label htmlFor="descricao">Descrição</label>
            <textarea
              id="descricao"
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
              placeholder="Descrição da checagem"
              required
            />
          </div>
          <div className="form-actions">
            <button type="button" onClick={onClose} className="btn-cancel">Cancelar</button>
            <button type="submit" className="btn-confirm" disabled={createChecagemMutation.isPending}>
              {createChecagemMutation.isPending ? 'Criando...' : 'Criar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CriarChecagemModal;
